import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { CharacterRoleSchema } from "../../fragments/CharacterRole";
import { CharacterDifficultySchema } from "../../fragments/CharacterDifficulty";
import { BackdropSchema } from "../../fragments/Backdrop";
import { RichTextSchema } from "../../fragments/RichText";
import { LinkItemSchema } from "../../fragments/LinkItem";
const CharacterMastheadBladeTypeValues = ["characterMasthead"];
export const CharacterMastheadBladeTypesSchema = z.enum(CharacterMastheadBladeTypeValues);
export const CharacterMastheadBladeTypes = CharacterMastheadBladeTypesSchema.enum;
export const CharacterMastheadBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema,
    title: z.string(),
    subtitle: z.string().optional(),
    role: CharacterRoleSchema.optional(),
    difficulty: CharacterDifficultySchema.optional(),
    description: RichTextSchema.optional(),
    linksLabel: z.string().optional(),
    links: z.array(LinkItemSchema).optional(),
});
export const CharacterMastheadBladesContractSchema = CharacterMastheadBladeSchema.extend({
    type: CharacterMastheadBladeTypesSchema,
});
export const CharacterMastheadBladeContractSchema = CharacterMastheadBladesContractSchema.extend({
    type: z.literal(CharacterMastheadBladeTypes.characterMasthead),
});
//# sourceMappingURL=index.js.map